import React from "react";
import { showValidation } from "./utilities/showValidation";
import { showLabel } from "./utilities/showLabel";

const ThresholdField = (props) => {
  let { formId, field } = props;
  let { element } = field;
  const thresholdChangeHandler = (e, blur) => {
    props.changeHandler(
      {
        target: {
          value: {
            thresholdVal: element.value.thresholdVal,
            thresholdPer: e.target.value,
          },
        },
      },
      blur,
    );
  };
  return (
    <div className="field-style">
      {showLabel(field, formId)}

      <div style={{ display: "flex", gap: "5px", width: "70%", alignItems: "center", justifyContent: "center" }}>
        <input
          disabled={element.disabled}
          id={formId + "_" + field.id}
          name={formId + "_" + field.id}
          type="number"
          onChange={(e) => thresholdChangeHandler(e, false)}
          onBlur={(e) => thresholdChangeHandler(e, true)}
          onKeyDown={(e) => e.key === "Enter" && props.onEnterPressed(e)}
          className="input-style"
          value={element.value.thresholdPer}
          style={{ width: "60%" }}
          placeholder={element.placeholder.visible ? element.placeholder.value : ""}
        />
        <input value={element.value.thresholdVal} disabled={true} style={{ width: "40%" }} />
      </div>

      {showValidation(field)}
    </div>
  );
};

export default ThresholdField;



// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/ThresholdField.jsx